import {navMenu, languageToggle} from './modules/mobile-nav-menu';
import {translateActivated} from './modules/langugae-script';
import {slides, revealOnScroll} from './modules/site-css-edits';
import {revealVideo} from './modules/video-modal';
import {arrowButtonSlide} from './modules/banner-scripts';

// Global Scripts
navMenu();
languageToggle();
// translateActivated();

// const revealSection = document.querySelector(".section");
// if (revealSection != null) revealOnScroll();

const homePage = document.querySelector(".homePage");
if (homePage != null) slides();

const videoModal = document.querySelector(".video-modal");
if (videoModal != null) {
    revealVideo();
}

const arrowButtonPresent = document.querySelector('.hero-scroll-button');
if (arrowButtonPresent)
{
    arrowButtonSlide();    
}


function browserSpecs()
{
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    // console.log(viewportHeight);
    console.log(`WINDOW WIDTH: ${ viewportWidth }`)
    console.log(`WINDOW HEIGHT: ${ viewportHeight }`)
    
}
browserSpecs();


